"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { _getGeoDataSource, _getGeoDataSourceIds } from "./queries";
export const getFirstGeoDataSource = (..._0) => __async(void 0, [..._0], function* (params = {}, fetchComplete = true) {
  if (!params.variables) {
    params.variables = {};
  }
  const apiQuery = fetchComplete ? _getGeoDataSource : _getGeoDataSourceIds;
  let page;
  try {
    page = yield apiQuery(params);
  } catch (error) {
    console.error(error);
    throw error;
  }
  if (!page) return { nodes: [], hasMore: false };
  const { hasNextPage = false } = (page == null ? void 0 : page.pageInfo) || {};
  return { nodes: page.nodes, hasMore: hasNextPage };
});
export default getFirstGeoDataSource;
